// The dialog shows one page and has no load-more, so it asks for as much as
// scribe will answer with at once.
export const REGISTRY_SELECTOR_PAGE_SIZE = 200;
